import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, signal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LayoutService } from '../../services/layout.service';
import { UserService } from '../../services/user.service';
import { snackbarConfig } from '../../../d2x-client/consts/snackbar-config.map';
import * as XLSX from 'xlsx';
import { forkJoin } from 'rxjs';
import { IMembershipExcelDto } from '../../classes/user.class';
import { format } from 'date-fns';

@Component({
  selector: 'app-sign-in',
  standalone: false,
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss'
})
export class SignInComponent implements OnInit {

  public hide = signal(true);

  public readonly id = new FormControl('', [Validators.required]);
  public readonly password = new FormControl('', [Validators.required, Validators.min(4)]);

  constructor(
    public readonly layoutService: LayoutService,
    public userService: UserService,
    private router: Router,
    private snackBar: MatSnackBar,
    private http: HttpClient,
  ) { }

  ngOnInit() {
    this.userService.checkLoginStatus();
  }

  public clickEvent(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

  public login() {
    console.log('logins!!!!');
    if (this.id.invalid || this.password.invalid) {
      this.snackBar.open('아이디 혹은 비밀번호를 올바르게 입력하세요.', '닫기', { duration: 3000 });
      return;
    }
    if (this.id.value === null || this.password.value === null) {
      this.snackBar.open('아이디 혹은 비밀번호를 입력하세요.', '닫기', { duration: 3000 });
      return;
    }

    this.userService.user.login({ 
      membershipId: this.id.value, password: this.password.value
     }).subscribe({
      next: (response: any) => {
        this.userService.userData = response.data;
        localStorage.setItem('user', JSON.stringify(this.userService.userData));
        this.userService.isLogin = true;
        this.userService.updateButtons();
    
        const lastProject = this.userService.userData.projects[this.userService.userData.projects.length - 1];
        const redirectTo = this.userService.projectRoutes[lastProject];
        this.router.navigate([`projects/${redirectTo}`]);
      },
      error: (error: HttpErrorResponse) => {
        this.userService.isLogin = false;
        this.snackBar.open('잘못된 로그인 정보입니다.', '닫기', { duration: 3000 });
      }
     })
    this.id.reset();
    this.password.reset();
  }

  public errorMessage(control: FormControl, fieldName: string): string {
    if (control.hasError('required')) {
      return `${fieldName}은(는) 필수 입력 사항입니다.`;
    } else if (control.hasError('minlength')) {
      return `비밀번호는 최소 ${control.getError('minlength').requiredLength}자 이상이어야 합니다.`;
    }
    return '';
  }

  protected uploadExcel() {
    console.log('click uploadExcel');
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx, .xls';

    input.onchange = async (e: any) => {
      const file: File = e.target.files[0];
      if (!file) {
        this.snackBar.open('엑셀 파일이 선택되지 않았습니다.', '', snackbarConfig);
        return;
      }

      const reader: FileReader = new FileReader();

      reader.onload = async (event: any) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const excelData: IMembershipExcelDto[] = XLSX.utils.sheet_to_json(sheet);
        const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');    
        
        console.log('excelData', excelData);
        const saveRequests = excelData.map((user: IMembershipExcelDto) => {
          const userData = {
            membershipId: user.membershipId,
            password: String(user.password),
            projects: JSON.parse(user.projects.replace(/'/g, '"')),
            createdAt: now
          };

          console.log('userData', userData);
          return this.userService.user.save(userData);
        });

        forkJoin(saveRequests).subscribe({
          next: (response) => {
            console.log('response', response);
            this.snackBar.open('회원가입이 완료되었습니다.', '', snackbarConfig);
            return;
          }
        });
      }

      reader.onerror = (error) => {
        console.error('파일 읽기 오류:', error);
      };

      reader.readAsArrayBuffer(file);
    }

    input.click();
  }

}
